import { render, staticRenderFns } from "./educatingPeople.vue?vue&type=template&id=5927a1a4&scoped=true"
import script from "./educatingPeople.vue?vue&type=script&lang=js"
export * from "./educatingPeople.vue?vue&type=script&lang=js"
import style0 from "./educatingPeople.vue?vue&type=style&index=0&id=5927a1a4&prod&scoped=scoped&lang=scss"
import style1 from "./educatingPeople.vue?vue&type=style&index=1&id=5927a1a4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5927a1a4",
  null
  
)

export default component.exports